import { useQuery } from "@tanstack/react-query";
import { createDownloadBlob, useStandardErrorHandler } from "modules/common";
import { createService } from "services/serviceFactory";

const documentsService = createService("documents");

export const getDocumentContentFullpath = async (fullPath: string) => {
    const response = await documentsService.get(`/documents/v1/documents/content`, {
        responseType: "blob",
        params: { path: fullPath },
    });
    return response.data;
};

const getDocumentContent = async (path: string, storageKey: string) => {
    const fullPath = `${storageKey}/${path}`;
    return getDocumentContentFullpath(fullPath);
};

export const useGetDocumentContentQuery = (path: string, storageKey: string) => {
    const errorHandler = useStandardErrorHandler("Greška pri dohvaćanju dokumenta");

    return useQuery({
        queryKey: ["documentContent", path, storageKey],
        queryFn: () => getDocumentContent(path, storageKey),
        enabled: Boolean(path),
        onError: errorHandler,
    });
};

export const downloadDocument = async (fullPath: string, fileName?: string) => {
    const data = await getDocumentContentFullpath(fullPath);
    const downloadFileName = fileName || fullPath.split("/").pop() || fullPath;
    createDownloadBlob(data, downloadFileName);
};

export const downloadUserManual = async () => {
    const response = await documentsService.get(`/documents/v1/documents/usermanual`, {
        responseType: "blob",
    });
    createDownloadBlob(response.data, "Korisnicke-upute-eSavjetnik.docx");
};